import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import { MediaQuery as MQ } from '../../media-query';
import { hasTouchEvents } from '../../util';
import NavbarMobile from './bar-mobile';

class Component extends BaseComponent {
    constructor() {
        super();
        this.state = { width: window.innerWidth };
    }

    componentDidMount() {
        window.addEventListener('resize', this.updateDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextState.width >= 900 && this.state.width < 900) {
            this.toggle();
            return true;
        }

        if (nextState.width < 900 && this.state.width >= 900) {
            return true;
        }

        if (nextProps.logged_in != this.props.logged_in) {
            return true;
        }

        return false;
    }

    render({ noads, class: className }) {
        if (MQ.isMobile() || MQ.isTabletPortrait() || (hasTouchEvents && MQ.isPortrait)) {
            return (
                <mobile-menu noads={noads} className={className}>
                    <a className='toggle-menu' onClick={this.toggle} ref={(el) => this.toggleMenu = el}>
                        <div className='icon'>
                            <span />
                            <span />
                            <span />
                            <span />
                        </div>
                    </a>
                    <mobile-nav onClick={this.handleClick}>
                        <NavbarMobile />
                    </mobile-nav>
                </mobile-menu>
            );
        }

        return (<mobile-menu noads={noads} className={className} />);
    }

    toggle = () => {
        const isOpen = this.toggleMenu && this.toggleMenu.classList && this.toggleMenu.classList.contains('open');
        const dfp_ad = document.querySelector('dfp[name="Top"]');
        const misc_elements = document.querySelectorAll('body, dfp[name="Top"], main, footer, top-bar, mobile-nav');
        const [action, label] = isOpen ? ['Close', 'X'] : ['Open', 'Hamburger'];

        this.props.trackEvent(['Navigation', action, label]);

        if (dfp_ad && dfp_ad.length) {
            if (isOpen) {
                dfp_ad.style.display = 'block';
                dfp_ad.style.height = 'auto';
            } else {
                dfp_ad.style.display = 'none';
                dfp_ad.style.height = 0;
            }
        }

        if (window.innerWidth >= 900) {
            this.closeNav(misc_elements);
        } else if (!isOpen) {
            this.closeNotify();
            if (this.toggleMenu.classList) {
                this.toggleMenu.classList.add('open');
            }

            misc_elements.forEach((el) => el.classList && el.classList.add('show-nav'));
        } else {
            this.closeNav(misc_elements);
        }
    }

    closeNav = (misc_elements) => {
        misc_elements.forEach((el) => el.classList && el.classList.remove('show-nav'));
        if (this.toggleMenu && this.toggleMenu.classList) {
            this.toggleMenu.classList.remove('open');
        }
    }

    closeNotify = () => {
        document.querySelectorAll('body, top-bar, main, footer, notifications-list, div.overlay').forEach((el) => {
            el.classList && el.classList.remove('show-notify');
        });
        const notifyIcon = document.querySelector('notifications-icon');
        if (notifyIcon && notifyIcon.classList) {
            notifyIcon.classList.remove('open');
        }
    }

    trackEvent = (category, label) => {
        const action = this.props.logged_in ? 'LI Click' : 'LO Click';
        this.props.trackEvent([category, action, label]);
    }

    updateDimensions = () => {
        this.setState({ width: window.innerWidth });
    }

    handleClick = (e) => {
        if (e.target.localName == 'nav') {
            this.toggle();
        }
    }
}

const mapStateToProps = (state) => ({
    logged_in: state.user && state.user.logged_in,
    pmp: state['promo-message-preview'],
});

const mapDispatchToProps = (dispatch) => ({
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);